import { apiClient } from '@/lib/apiClient';
import type {
  PaginadoComResumo,
  FiltrosListaCompras,
  RfqResumo,
  RfqDetalhe,
  RfqFornecedor,
  CriarRfqRequest,
  AtualizarRfqRequest,
  RegistrarRespostaFornecedorRequest,
  AdjudicarRfqRequest,
  StatusRfq,
  EnviarRfqResponse,
} from '../types';
import { paramsListaCompras } from '../types';

const BASE = '/api/compras/cotacoes';

export const rfqService = {
  /** Lista paginada; status, busca (número/título), período de emissão e ordenação são feitos no servidor. */
  getAll: (pagina = 1, tamanhoPagina = 20, status?: StatusRfq, filtros: FiltrosListaCompras = {}) =>
    apiClient.get<PaginadoComResumo<RfqResumo>>(BASE, {
      params: { pagina, tamanhoPagina, ...(status ? { status } : {}), ...paramsListaCompras(filtros) },
    }).then(r => r.data),

  getById: (id: number) =>
    apiClient.get<RfqDetalhe>(`${BASE}/${id}`).then(r => r.data),

  create: (data: CriarRfqRequest) =>
    apiClient.post<RfqDetalhe>(BASE, data).then(r => r.data),

  update: (id: number, data: AtualizarRfqRequest) =>
    apiClient.put<RfqDetalhe>(`${BASE}/${id}`, data).then(r => r.data),

  enviar: (id: number) =>
    apiClient.post<EnviarRfqResponse>(`${BASE}/${id}/enviar`).then(r => r.data),

  encerrar: (id: number) =>
    apiClient.post<RfqResumo>(`${BASE}/${id}/encerrar`).then(r => r.data),

  adjudicar: (id: number, data: AdjudicarRfqRequest) =>
    apiClient.post<RfqDetalhe>(`${BASE}/${id}/adjudicar`, data).then(r => r.data),

  registrarResposta: (id: number, fornecedorId: number, data: RegistrarRespostaFornecedorRequest) =>
    apiClient.post<RfqFornecedor>(`${BASE}/${id}/fornecedores/${fornecedorId}/resposta`, data).then(r => r.data),

  comparativo: (id: number) =>
    apiClient.get<RfqDetalhe>(`${BASE}/${id}/comparativo`).then(r => r.data),
};
